
import React from 'react';

const ContactHero = () => {
  return (
    <section className="bg-brand-lightBlue pt-28 md:pt-32 pb-12 md:pb-16 relative">
      <div className="absolute inset-0 opacity-10">
        <img 
          src="https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1469&q=80"
          alt="Vlaams team vergadert"
          className="w-full h-full object-cover"
          loading="lazy"
          width="1469"
          height="980"
        />
      </div>
      <div className="container relative z-10">
        <div className="text-center max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Start vandaag met het beste B2B callcenter in Vlaanderen
          </h1>
          <p className="text-gray-700 text-lg md:text-xl">
            Ontvang binnen 24 uur een vrijblijvend groeiplan op maat van jouw bedrijf.
          </p>
        </div>
      </div>
    </section>
  );
};

export default ContactHero;
